import { gql } from "@apollo/client";
import { LimitOffsetPaginationInput, LimitOffsetPaginationMeta } from "../../sharedTypes";

export interface Version {
	version_id: number
	version: string
}

export interface VersionPaginationResult {
	data: Version[]
	meta: LimitOffsetPaginationMeta
}

export const VERSIONS = gql`
query VersionsPaginated($pagination: LimitOffsetPaginationInput!, $sort: SortDirection) {
	server {
		versionsPaginated(pagination: $pagination, sort: $sort) {
			data {
				version_id
				version
			}
			meta {
				limit
				offset
				hasPreviousPage
				hasNextPage
				totalCount
			}
		}
	}
}
`

export interface VersionsResponse {
	server: {
		versionsPaginated: VersionPaginationResult
	}
}

export interface VersionsArgs {
	pagination: LimitOffsetPaginationInput
	sort?: 'ASC' | 'DESC'
}

